import { z } from 'zod';
import { UserId } from './User';

const PostActivityPayload = z.object({
  type: z.literal('post'),
  id: z.string(),
  title: z.string(),
});

const EventActivityPayload = z.object({
  type: z.literal('event'),
  id: z.string(),
  title: z.string(),
});

const CampaignActivityPayload = z.object({
  type: z.literal('campaign'),
  id: z.string(),
  title: z.string(),
});

const TopicActivityPayload = z.object({
  type: z.literal('topic'),
  id: z.string(),
  title: z.string(),
});

export const ActivityId = z.string().brand('ActivityId');
export const Activity = z.object({
  id: ActivityId,
  createdAt: z.string().datetime({ offset: true }),
  userId: UserId,
  userName: z.string(),
  userAvatarURL: z.string().url().optional(),
  type: z.enum(['post', 'event', 'campaign', 'topic']),
  payload: z.union([
    PostActivityPayload,
    EventActivityPayload,
    CampaignActivityPayload,
    TopicActivityPayload,
  ]),
});
export type ActivityType = z.infer<typeof Activity>;
